<script>
  import MenuDialogSectionTitle from "../../../components/layout/menuDialog/MenuDialogSectionTitle.svelte";
  import { translate } from "../../../i18n/i18next.js";
  import MenuDialogSectionEntry from "../../../components/layout/menuDialog/MenuDialogSectionEntry.svelte";
  import MenuDialogSectionEntryTitle from "../../../components/layout/menuDialog/MenuDialogSectionEntryTitle.svelte";
  import ChartDisplaySpanSelection from "../../../components/chart/ChartDisplaySpanSelection.svelte";
  import GeneralInput from "../../../components/input/GeneralInput.svelte";
  import { onMount, tick } from "svelte";
  import CenteredMenuDialog from "../../../components/layout/menuDialog/variants/CenteredMenuDialog.svelte";
  import DialogTitle from "../../../components/dialog/DialogTitle.svelte";
  import DialogSplitter from "../../../components/dialog/DialogSplitter.svelte";
  import DialogContent from "../../../components/dialog/DialogContent.svelte";
  import DialogBottomControls from "../../../components/dialog/DialogBottomControls.svelte";
  import DialogBottomControlButton from "../../../components/dialog/DialogBottomControlButton.svelte";
  import ToggleSwitch from "../../../components/input/ToggleSwitch.svelte";
  import HelpTooltip from "../../../components/tooltip/HelpTooltip.svelte";

  export let GanttStore
  export let onClose

  let dialog

  const {
    DisplayedRowCount,
    DisplayedSpanInSeconds,
    HideDaysOff,
    HideWeekEnds,
  } = GanttStore

  function closeDialog() {
    dialog.close()
    onClose()
  }

  onMount(async () => {
    await tick()
    dialog.showModal()
  })
</script>

<CenteredMenuDialog bind:dialog={dialog} onClose={closeDialog}>
  <DialogTitle title={translate("frontend:ganttChart.settings.sections.displaySettings.title")}/>
  <DialogSplitter />
  <DialogContent>
    <!-- <MenuDialogSectionTitle>
      {translate("frontend:ganttChart.settings.sections.displaySettings.title")}
    </MenuDialogSectionTitle> -->

    <!-- Display span settings -->
    <MenuDialogSectionEntry>
      <MenuDialogSectionEntryTitle>
        {translate("frontend:ganttChart.settings.displaySpan.label")}
      </MenuDialogSectionEntryTitle>
      <ChartDisplaySpanSelection
        currentValueInSeconds={$DisplayedSpanInSeconds}
        onChange={(newSpan) => {
          DisplayedSpanInSeconds.set(newSpan);
        }}
      />
    </MenuDialogSectionEntry>

    <!-- Number of rows settings -->
    <MenuDialogSectionEntry>
      <MenuDialogSectionEntryTitle>
        {translate("frontend:ganttChart.settings.displayedRowCount.label")}
      </MenuDialogSectionEntryTitle>
      <GeneralInput
        type="number"
        min={1}
        value={$DisplayedRowCount}
        onInput={(e) => {
          const rows = Math.floor(parseInt(e.target.value, 10))
          DisplayedRowCount.set(rows)
        }}
        extraStyle="width: 100%"
      />
    </MenuDialogSectionEntry>

    <!-- Hide Days Off settings -->
    <MenuDialogSectionEntry>
      <div class="toggle-switch-container">
        <MenuDialogSectionEntryTitle>
          {translate("frontend:ganttChart.settings.hideHolidays.label")}
          <HelpTooltip title={translate("frontend:ganttChart.settings.hideHolidays.label")}>
            {translate("frontend:ganttChart.settings.hideHolidays.tooltip")}
          </HelpTooltip>
        </MenuDialogSectionEntryTitle>
        <div class="toggle-switch">
          <ToggleSwitch
            on={$HideDaysOff}
            onChange={async (e) => {
              HideDaysOff.set(e.target.checked)
            }}
          />
        </div>
      </div>
    </MenuDialogSectionEntry>

    <!-- Hide Weekends settings -->
    <MenuDialogSectionEntry>
      <div class="toggle-switch-container">
        <MenuDialogSectionEntryTitle>
          {translate("frontend:ganttChart.settings.hideWeekEnds.label")}
          <HelpTooltip title={translate("frontend:ganttChart.settings.hideWeekEnds.label")}>
            {translate("frontend:ganttChart.settings.hideWeekEnds.tooltip")}
          </HelpTooltip>
        </MenuDialogSectionEntryTitle>
        <div class="toggle-switch">
          <ToggleSwitch
            on={$HideWeekEnds}
            onChange={async (e) => {
              HideWeekEnds.set(e.target.checked)
            }}
          />
        </div>
      </div>
    </MenuDialogSectionEntry>

  </DialogContent>
  <DialogSplitter/>
  <DialogBottomControls>
    <DialogBottomControlButton type="primary" onClick={onClose}>OK</DialogBottomControlButton>
  </DialogBottomControls>
</CenteredMenuDialog>
